"use client";
import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, Rocket, Sparkles } from "lucide-react";
import Link from "next/link";
import { useAuth } from "@/context/AuthContext";

const CTASection = () => {
  const { user } = useAuth();
  const getStartedHref = user ? "/dashboard" : "/register";
  const getStartedText = user ? "Go to Dashboard" : "Start Building Free";
  return (
    <section className="py-24 bg-background relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="relative rounded-[2.5rem] overflow-hidden bg-primary text-background text-center px-6 py-20 md:py-24 shadow-2xl"
        >
          {/* Background Gradients */}
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(255,255,255,0.15),transparent_50%)]" />
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_left,rgba(0,0,0,0.1),transparent_50%)]" />

          {/* Floating Elements */}
          <motion.div
            animate={{ y: [0, -10, 0] }}
            transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
            className="absolute top-10 left-10 md:left-20 opacity-20"
          >
            <Sparkles className="w-12 h-12 text-background" />
          </motion.div>
          <motion.div
            animate={{ y: [0, 10, 0] }}
            transition={{ duration: 5, repeat: Infinity, ease: "easeInOut", delay: 1 }}
            className="absolute bottom-10 right-10 md:right-20 opacity-20"
          >
            <Rocket className="w-12 h-12 text-background" />
          </motion.div>

          <div className="relative z-10 max-w-3xl mx-auto space-y-8">
            <h2 className="text-4xl md:text-6xl font-bold tracking-tight leading-tight">
              Ready to Build Your <br />
              <span className="opacity-90">Dream Backend?</span>
            </h2>

            <p className="text-lg md:text-xl opacity-90 max-w-2xl mx-auto leading-relaxed">
              Join thousands of developers who are shipping faster with our visual backend builder. No credit card required.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
              <Link
                href={getStartedHref}
                className="group relative inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-primary bg-background rounded-full hover:bg-surface transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-1"
              >
                {getStartedText}
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Link>

              <Link
                href="/docs"
                className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-background border-2 border-background/20 rounded-full hover:bg-background/10 transition-all duration-300"
              >
                View Documentation
              </Link>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;